import { isPlatformBrowser, NgIf } from '@angular/common';
import { Component, Inject, input, OnInit, output, PLATFORM_ID } from '@angular/core';
// pake relative path biar lebih fleksibel
import { ShareButtonComponent } from '../../../../shared/components/share-button/share-button.component';
import { SafePipe } from '@shared/pipe.safe';
import { environment } from '@environments/environment';

@Component({
  selector: 'content-landing',
  standalone: true,
  imports: [ShareButtonComponent, NgIf, SafePipe ],
  templateUrl: './content-landing.component.html',
  styleUrl: './content-landing.component.scss'
})

export class ContentLandingComponent implements OnInit {
  imageUrl = input<string>('');
  description = input<string>('');
  title = input<string>('');

  // Output untuk komunikasi dengan parent component
  promoInteraction = output<{action: string, label?: string}>();

  isShow: boolean = false;
  isMobile: boolean = false;
  // mapping domain di usecase jgn disini
  domain: string = environment.serviceApi;

  constructor(
    @Inject(PLATFORM_ID) public platformId: object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const MIN_WIDTH = 768;
      if (window.innerWidth < MIN_WIDTH) {
        this.isMobile = true;
      }
    }
  }

  onClickShare() {
    // Track share interaction
    this.promoInteraction.emit({
      action: 'share_promo',
      label: this.title()
    });

    if (this.isMobile) {
      const shareData: ShareData = {
        title: this.title(),
        url: window.location.href
      };
      navigator.share(shareData);
      return;
    }
    this.isShow = !this.isShow;
  }

  onBannerClick() {
    // Track banner click interaction
    this.promoInteraction.emit({
      action: 'banner_click',
      label: this.title()
    });
  }
}
